<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'StepLaunch',
})
</script>
<template>
  <TlDetailItem :title="title" color="blue">
    <TlDetailField label="发起人">{{ record?.createAdminUserObj?.loginName }}</TlDetailField>
    <TlDetailField label="发起时间">{{ record?.createdAt }}</TlDetailField>
    <TlDetailField label="保险名称">{{ record?.name }}</TlDetailField>
    <TlDetailField label="在册农业人口">{{ record?.farmerNumber ?? 0 }} 人</TlDetailField>
    <TlDetailField label="幅员面积">{{ record?.areaSize ?? 0 }} 亩</TlDetailField>
    <TlDetailField label="报告函">
      <FileDisplayNormals :files="record?.reportFiles ?? []" :colAttrs="{ span: 12 }" />
    </TlDetailField>
    <TlDetailField label="基础情况表">
      <FileDisplayNormals :files="record?.basicFiles ?? []" :colAttrs="{ span: 12 }" />
    </TlDetailField>
  </TlDetailItem>
</template>

<script lang="ts" setup name="StepLaunch">
import { FileDisplayNormals } from '-/Common/FileDisplay'
import TlDetailField from '../common/TlDetailField.vue'
import TlDetailItem from '../common/TlDetailItem.vue'
import { computed } from 'vue'
const props = defineProps<{
  record?: any
  isRenew?: boolean
}>()
const title = computed(() => (props.isRenew ? '重新发起' : '发起') + '-参保名额测算')
</script>
